import { ArrowLeftOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import React from 'react';
import { Link } from 'react-router-dom';
import EmptyItems from './common/EmptyItems';

const LinkAccount = () => (
  <EmptyItems
    Icon={UsergroupAddOutlined}
    title="Ce lien n'est plus valide"
  >
    <p>Le lien de création de compte que vous avez utilisé n'est plus valide ou a déjà été utilisé.</p>
    <p>Si vous n'avez pas encore accès à FlexiDocs, contactez un administrateur afin qu'il vous renvoie une invitation.</p>
    <Link to="/" className="inline-flex items-center gap-2 mt-4 font-medium text-flexi-primary-color hover:underline">
      <ArrowLeftOutlined />
      Retour à la page de connexion
    </Link>
  </EmptyItems>
);

export default LinkAccount;
